// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".freelance-examples ul{list-style:none;padding:0}.freelance-examples ul li.card{box-shadow:none}.freelance-examples ul li.card .card-title{font-size:1.35rem}@media (max-width: 767.98px){.freelance-examples ul li.card .card-title{font-size:1.2rem}}\n", ""]);
// Exports
module.exports = exports;
